import Backbone from 'backbone';
import messageTemplate from '../template/message-block.pug';

export default class View extends Backbone.View {
  initialize({
    messageBlock, midMessageBlock, subMessageBlock, infoAlertMessage, imageClass, messageClass,
  }) {
    this.mainMessage = messageBlock;
    this.subMessage = subMessageBlock;
    this.midMessageBlock = midMessageBlock;
    this.infoAlertMessage = infoAlertMessage;
    this.imageClass = imageClass;
    this.messageClass = messageClass;
  }

  render() {
    this.$el.html(messageTemplate({
      mainMessage: this.mainMessage,
      subMessage: this.subMessage,
      showMidMessageBlock: this.midMessageBlock,
      infoAlertMessage: this.infoAlertMessage,
      imageClass: this.imageClass,
      messageClass: this.messageClass,
    }));
    if (this.midMessageBlock) {
      if (this.midMessageBlock instanceof Backbone.View) {
        this.midMessageBlock.render();
        this.$('.lightbox-mid-content').append(this.midMessageBlock.el);
      } else {
        this.$('.lightbox-mid-content').append(this.midMessageBlock);
      }
    }
    if (this.infoAlertMessage) {
      this.$('.alert.alert-info').addClass('lightbox-alert');
    }
    return this;
  }
}
